import classNames from "classnames";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { supportEmail } from "@utils/membership/membershipUtils";
import { Link } from "react-router-dom";
import { getCurrentCulture } from "@utils";

export default function PlayerSowInfo(props: { isFullForm?: boolean }) {
	const { t } = useTranslation("account-verification");

	const [toggleFilter, setToggleFilter] = useState(true);

	const accordionHeaderClass = classNames(
		"card__header btn btn--block btn--reset",
		{
			"is-expanded": toggleFilter,
			"is-collapsed": !toggleFilter,
		}
	);

	const accordionIconClass = classNames("u-icon u-icon--tny", {
		"u-icon--caret--up": toggleFilter,
		"u-icon--caret--down": !toggleFilter,
	});

	return (
		<div className="card card--primary u-mar--top--xsml">
			<button
				type="button"
				className={accordionHeaderClass}
				onClick={() => setToggleFilter(!toggleFilter)}
			>
				<span className="card__title card__title--med u-type--left">
					{t("INSTRUCTIONS")}
				</span>
				<i className={accordionIconClass} />
			</button>

			{toggleFilter && (
				<div className="card__body u-type--base u-color--text--secondary">
					{props.isFullForm && (
						<div className="card__section">
							<div className="u-mar--bottom--xtny">
								{t("PLAYER_SOW.INSTRUCTIONS.TITLE")}
							</div>
						</div>
					)}
					<div className="card__section">
						<div className="u-mar--bottom--xtny">
							{t("PLAYER_SOW.UPLOAD_GUIDELINES.TITLE")}
						</div>
						<ol className="list list--ordered">
							<li className="u-mar--bottom--xtny">
								{t(
									"PLAYER_SOW.UPLOAD_GUIDELINES.DOCUMENT_FORMATS"
								)}
							</li>
							<li className="u-mar--bottom--xtny">
								{t(
									"PLAYER_SOW.UPLOAD_GUIDELINES.DOCUMENT_SIZE"
								)}
							</li>
							<li className="u-mar--bottom--xtny">
								{t(
									"PLAYER_SOW.UPLOAD_GUIDELINES.DOCUMENT_QUALITY"
								)}
							</li>
						</ol>
					</div>

					<div>
						{t(
							"PLAYER_SOW.UPLOAD_GUIDELINES.SUPPORT_EMAIL_MESSAGE",
							{
								email: supportEmail,
							}
						)}
					</div>
					<Link
						to={`/${getCurrentCulture()}/support-chat`}
						className="card--empty__btn btn btn--med btn--block btn--primary--inverted btn--icon u-mar--top--xsml"
						target="_blank"
					>
						{t("CHAT.SUPPORT.TITLE")}{" "}
						<i className="u-icon u-icon--tny u-icon--arrow-right" />
					</Link>
				</div>
			)}
		</div>
	);
}
